<template>
  <router-view />
</template>

<script setup>
function init() {
  FB.AppEvents.logPageView();
}

window.fbAsyncInit = function () {
  FB.init({
    appId: process.env.VUE_APP_FACEBOOK_CLIENT_ID,
    cookie: true,
    xfbml: true,
    version: "v25.0",
  });

  init();
};

(function (d, s, id) {
  var js,
    fjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {
    return;
  }
  js = d.createElement(s);
  js.id = id;
  js.src = "https://connect.facebook.net/en_US/sdk.js";
  fjs.parentNode.insertBefore(js, fjs);
})(document, "script", "facebook-jssdk");
</script>
